import { inject, type InjectionKey } from "vue";
import type { AuthService } from "./authService";

export const AuthServiceSymbol: InjectionKey<AuthService> = Symbol(
  "AuthServiceInjectionKey"
);

export function injectStrict<T>(key: InjectionKey<T>, fallback?: T) {
  const resolved = inject(key, fallback);
  if (!resolved) {
    throw new Error(`Could not resolve ${key.description}`);
  }
  return resolved;
}
